import { InMemoryWebStorage, UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { appconfig } from '../config/appconfig';

export const userManager = new UserManager({
  authority: appconfig.idp.authority,
  client_id: appconfig.idp.client_id,
  redirect_uri: appconfig.idp.redirect_uri,
  post_logout_redirect_uri: appconfig.idp.post_logout_redirect_uri,

  // Note: currently we must support legacy login with ocs.web
  // as well as identity service but only the latter supports OIDC.
  // So we cannot rely on the user manager for session persistence
  // instead we rely on the our own app logic.
  userStore: new WebStorageStateStore({
    store: new InMemoryWebStorage(),
  }),
});
